import api from "./api";

const deliveryProfileService = {
  // Get all delivery profiles with filtering and pagination
  getDeliveryProfiles: async (params = {}) => {
    try {
      const response = await api.get("/api/delivery-profiles", { params });
      return response.data;
    } catch (error) {
      console.error("Error fetching delivery profiles:", error);
      throw error;
    }
  },

  // Get delivery profile by ID
  getDeliveryProfileById: async (id) => {
    try {
      const response = await api.get(`/api/delivery-profiles/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching delivery profile by ID:", error);
      throw error;
    }
  },

  // Get delivery profile by email
  getDeliveryProfileByEmail: async (email) => {
    try {
      const response = await api.get(`/api/delivery-profiles/email/${email}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching delivery profile by email:", error);
      throw error;
    }
  },

  // Create new delivery profile (multipart)
  createDeliveryProfile: async (profileData, files = {}) => {
    try {
      console.log("=== CREATE DELIVERY PROFILE DEBUG ===");
      console.log("Profile data:", profileData);
      console.log("Files received:", files);

      const formData = new FormData();
      // append text fields
      Object.entries(profileData || {}).forEach(([k, v]) => {
        if (v !== undefined && v !== null) formData.append(k, v);
      });

      // supported files: image, aadhar_card, pan_card, driving_licence
      const fileFields = [
        "image",
        "aadhar_card",
        "pan_card",
        "driving_licence",
      ];
      fileFields.forEach((fieldName) => {
        if (files[fieldName]) {
          console.log(`Appending file: ${fieldName}`, {
            name: files[fieldName].name,
            type: files[fieldName].type,
            size: files[fieldName].size,
          });
          formData.append(fieldName, files[fieldName]);
        } else {
          console.log(`No file provided for field: ${fieldName}`);
        }
      });

      console.log("FormData prepared, sending request...");
      const response = await api.post("/api/delivery-profiles", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log("Response received:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error creating delivery profile:", error);
      console.error("Error details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      throw error;
    }
  },

  // Update delivery profile (multipart)
  updateDeliveryProfile: async (id, profileData, files = {}) => {
    try {
      console.log("=== UPDATE DELIVERY PROFILE DEBUG ===");
      console.log("Profile ID:", id);
      console.log("Profile data:", profileData);
      console.log("Files received:", files);

      const formData = new FormData();
      Object.entries(profileData || {}).forEach(([k, v]) => {
        if (v !== undefined && v !== null) formData.append(k, v);
      });

      // supported files: image, aadhar_card, pan_card, driving_licence
      const fileFields = [
        "image",
        "aadhar_card",
        "pan_card",
        "driving_licence",
      ];
      fileFields.forEach((fieldName) => {
        if (files[fieldName]) {
          console.log(`Appending file: ${fieldName}`, {
            name: files[fieldName].name,
            type: files[fieldName].type,
            size: files[fieldName].size,
          });
          formData.append(fieldName, files[fieldName]);
        } else {
          console.log(`No file provided for field: ${fieldName}`);
        }
      });

      console.log("FormData prepared, sending request...");
      const response = await api.put(`/api/delivery-profiles/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log("Response received:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error updating delivery profile:", error);
      console.error("Error details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      throw error;
    }
  },

  // Delete delivery profile
  deleteDeliveryProfile: async (id) => {
    try {
      const response = await api.delete(`/api/delivery-profiles/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting delivery profile:", error);
      throw error;
    }
  },

  // Activate delivery profile
  activateDeliveryProfile: async (id) => {
    try {
      const response = await api.patch(`/api/delivery-profiles/${id}/activate`);
      return response.data;
    } catch (error) {
      console.error("Error activating delivery profile:", error);
      throw error;
    }
  },

  // Deactivate delivery profile
  deactivateDeliveryProfile: async (id) => {
    try {
      const response = await api.patch(
        `/api/delivery-profiles/${id}/deactivate`
      );
      return response.data;
    } catch (error) {
      console.error("Error deactivating delivery profile:", error);
      throw error;
    }
  },

  // Approve delivery profile
  approveDeliveryProfile: async (id) => {
    try {
      const response = await api.patch(`/api/delivery-profiles/${id}/approve`);
      return response.data;
    } catch (error) {
      console.error("Error approving delivery profile:", error);
      throw error;
    }
  },

  // Get delivery profile statistics
  getDeliveryProfileStats: async () => {
    try {
      const response = await api.get("/api/delivery-profiles/stats");
      return response.data;
    } catch (error) {
      console.error("Error fetching delivery profile stats:", error);
      throw error;
    }
  },

  // Get delivery history for a delivery boy
  getDeliveryHistory: async (id, params = {}) => {
    try {
      const response = await api.get(
        `/api/delivery-profiles/${id}/delivery-history`,
        { params }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching delivery history:", error);
      throw error;
    }
  },
};

export default deliveryProfileService;
